var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "w-100" }, [
    _c("div", { staticClass: "row select-another-carrier mx-4 p-4" }, [
      _c("div", { staticClass: "col-12" }, [
        _vm.carrierData.logoPathSvg
          ? _c("span", { staticClass: "carrier-logo" }, [
              _c("img", {
                attrs: {
                  src: _vm.carrierData.logoPathSvg,
                  alt: _vm.carrierData.carrier_name
                }
              })
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 msg-col" }, [
        !_vm.errorMessage
          ? _c("p", [
              _c("strong", [_vm._v("Reminder:")]),
              _vm._v(" If you did not already, please continue to the "),
              _c("strong", [
                _vm._v(_vm._s(_vm.carrierData.carrier_name) + "'s")
              ]),
              _vm._v(
                " agent platform in a new browser tab to complete the bind of this " +
                  _vm._s(_vm.carrierType) +
                  " policy."
              )
            ])
          : _c("p", {
              staticClass: "m-0",
              domProps: { innerHTML: _vm._s(_vm.errorMessage.msg) }
            })
      ]),
      _vm._v(" "),
      !_vm.errorMessage
        ? _c("div", { staticClass: "col-12" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary continue-to-carrier",
                attrs: { type: "submit" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.continueToCarrier($event)
                  }
                }
              },
              [
                _vm._v(
                  "\n        CONTINUE TO " +
                    _vm._s(_vm.carrierData.carrier_name) +
                    "\n        "
                ),
                _c("i", { staticClass: "fa fa-open-in-new ml-1" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        viewBox: "0 0 16 16",
                        fill: "currentColor"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M9.33333 2V3.33333H11.7267L5.17333 9.88667L6.11333 10.8267L12.6667 4.27333V6.66667H14V2M12.6667 12.6667H3.33333V3.33333H8V2H3.33333C2.59333 2 2 2.6 2 3.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V8H12.6667V12.6667Z",
                          fill: "currentColor"
                        }
                      })
                    ]
                  )
                ])
              ]
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1edfaed5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1edfaed5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/interview/shared/BundleConfirmationReminder.vue
// module id = null
// module chunks = 